import { render, staticRenderFns } from "./DialogAddGroup.vue?vue&type=template&id=03bd27fb"
import script from "./DialogAddGroup.vue?vue&type=script&lang=js"
export * from "./DialogAddGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports